import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import { StudentFilterDialogValues } from "src/models/Student.model";
import ATMDatePicker from "src/components/UI/atoms/formFields/ATMDatePicker/ATMDatePicker";
import moment from "moment";
import { useGetAllBatchesQuery } from "src/services/BatchServices";
import ATMMultiSelect from "src/components/UI/atoms/formFields/ATMMultiSelect/ATMMultiSelect";

type Props = {
  formikProps: FormikProps<StudentFilterDialogValues>;
  onClose: () => void;
  onReset: any;
};

const StudentFilterDialog = ({ formikProps, onClose, onReset }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } =
    formikProps;

  const { data, isLoading, isFetching } = useGetAllBatchesQuery("");

  const batchOptions = data?.data?.map((el: any, ind: any) => {
    return {
      label: el?.batchName,
      value: el?._id,
    };
  });

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">Filters</div>
        <button
          type="button"
          className="hover:bg-hover text-red-800"
          onClick={() => {
            onReset();
            setFieldValue("startDate", null);
            setFieldValue("endDate", null);
            setFieldValue("batchs", []);
          }}
        >
          Reset Filters
        </button>
      </div>
      <div className="flex flex-col gap-4">
        {/* Inquiry Date */}
        <div className="border-l-[3px] border-primary-dark px-3 font font-medium text-[18px]  bg-white  text-primary-dark">
          Date
        </div>
        <div className="grid grid-cols-2 gap-6">
          <div>
            <ATMDatePicker
              name="startDate"
              value={values.startDate}
              onChange={(newValue) => setFieldValue("startDate", newValue)}
              label="Start Date"
              format="DD-MM-YYYY"
              maxDate={moment().format("yyyy-MM-DD")}
            />
          </div>

          <div>
            <ATMDatePicker
              name="endDate"
              value={values.endDate}
              onChange={(newValue) => setFieldValue("endDate", newValue)}
              label="End Date"
              format="DD-MM-YYYY"
              minDate={values?.startDate || null}
            />
          </div>
        </div>
        {/* Next FollowUp Date */}
        {/* <div className="border-l-[3px] border-primary-dark px-3 font font-medium text-[18px]  bg-white  text-primary-dark">
          Next Installment Date
        </div>
        <div className="grid grid-cols-2 gap-6">
          <div>
            <ATMDatePicker
              name="nextInstallmentStartDate"
              value={values?.nextInstallmentStartDate}
              onChange={(newValue) =>
                setFieldValue("nextInstallmentStartDate", newValue)
              }
              label="Start Date"
              format="DD-MM-YYYY"
              maxDate={moment().format("yyyy-MM-DD")}
            />
          </div>

          <div>
            <ATMDatePicker
              name="nextInstallmentEndDate"
              value={values?.nextInstallmentEndDate}
              onChange={(newValue) =>
                setFieldValue("nextInstallmentEndDate", newValue)
              }
              label="End Date"
              format="DD-MM-YYYY"
              minDate={values?.nextInstallmentEndDate || null}
            />
          </div>
        </div>  */}
        <div>
          <ATMMultiSelect
            name="batchs"
            value={values?.batchs}
            onChange={(newValue) => setFieldValue("batchs", newValue)}
            onBlur={handleBlur}
            label="Batches"
            placeholder="Select Batches"
            options={batchOptions}
            isLoading={isFetching || isLoading}
          />
        </div>
      </div>
      <div className="flex gap-2">
        <button
          type="button"
          className="border w-full rounded p-2 h-[42px] flex gap-2 justify-center items-center bg-slate-200 hover:bg-slate-300"
          onClick={onClose} // Call onClsoe when clicked the button
        >
          Close
        </button>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Apply
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default StudentFilterDialog;
